/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";

const AddInPlaceButton = (props) => {
    const { onClick } = props;

    return (
        <div className='add-in-place-button-container'>
            <Button className='add-in-place-button' onClick={onClick}>
                <SVGIcons.common.AddOutlined />
            </Button>
        </div>
    );
};

export { AddInPlaceButton };
